export default {
  'fr-FR': {
    short: {
      year: 'numeric', month: 'long', day: 'numeric'
    },
  },
  'en-US': {
    short: {
      year: 'numeric', month: 'short', day: 'numeric'
    },
  }
}
